module.exports = __webpack_public_path__ + "static/img/mission-new-1.02e2374.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/mission-new-1.jpg
// module id = IjuI
// module chunks = 1